var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGestores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 28,
    viewBox: "0 0 38 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0807 7.4C29.8584 10.4502 27.5687 12.8 25.0719 12.8C22.575 12.8 20.2816 10.451 20.063 7.4C19.8353 4.22675 22.0643 2 25.0719 2C28.0794 2 30.3084 4.2845 30.0807 7.4Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0719 17.6001C20.1261 17.6001 15.3699 20.0278 14.1784 24.7558C14.0206 25.3813 14.4175 26.0001 15.0679 26.0001H35.0767C35.7271 26.0001 36.1218 25.3813 35.9662 24.7558C34.7747 19.9521 30.0186 17.6001 25.0719 17.6001Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7505 8.74565C14.5729 11.1816 12.7226 13.1001 10.7282 13.1001C8.73377 13.1001 6.88049 11.1824 6.70594 8.74565C6.52456 6.2114 8.32547 4.40015 10.7282 4.40015C13.1309 4.40015 14.9319 6.2579 14.7505 8.74565Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2059 17.7501C13.8361 17.1299 12.3273 16.8914 10.7283 16.8914C6.78193 16.8914 2.97975 18.8301 2.0273 22.6064C1.90208 23.1059 2.21931 23.6001 2.73841 23.6001H11.2595",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGestores);
export default __webpack_public_path__ + "static/media/icon-gestores.2193de1c0765c63fa442e8d7f97aa70a.svg";
export { ForwardRef as ReactComponent };